module.exports = __webpack_public_path__ + "img/mctsib_norms_screenshot_iphone13.3d2d883a.png";